import type { ConfigRouteParamsRequest } from '@pba/utils';
import type { Pagination } from 'models';
import { useCallback } from 'react';
import type { EventParticipantsPathRequestParams, EventParticipantsQueryRequestParams } from '../../../services';
import type { EventParticipantsFilter, EventParticipantsPageParameter } from '../useEventParticipantsInfiniteQuery';

export const useGetEventParticipantsParameters = () =>
  useCallback(
    ({
      filter,
      pageParam,
      pagination,
    }: {
      filter: EventParticipantsFilter;
      pageParam: EventParticipantsPageParameter;
      pagination: Omit<Pagination, 'position'>;
    }): ConfigRouteParamsRequest<EventParticipantsQueryRequestParams, EventParticipantsPathRequestParams> => ({
      config: {
        params: {
          $limit: pagination.pageSize,
          $search: filter.search,
          $skip: pageParam.skip,
          role: filter.role,
          rsvp: filter.rsvp,
        },
      },
      routeParams: {
        eventId: filter.eventId,
      },
    }),
    [],
  );
